import './styles/main.css';
import { renderApp } from './app/render.js';
import { ambientTrack } from './content/tracks.js';
import { initParticles } from './js/particles.js';
import { initScrollReveal } from './js/scroll.js';
import { initAudioToggle } from './js/audio.js';
import { initSmoothAnchors } from './js/navigation.js';
import { initStonesDialog } from './js/stones.js';

const root = document.querySelector('#app');
renderApp(root);

initParticles(document.getElementById('particles'));
initScrollReveal();
initAudioToggle(document.getElementById('audioToggle'), ambientTrack);
initSmoothAnchors();
initStonesDialog();
